/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import { styled, Typography } from '@nextiva/next-ui-components';
import {
  cxChatBannerBodyText,
  cxChatBannerLinkText,
} from 'constants/nextivaCX';

const StyledContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  height: 32px;
`;
const StyledLink = styled('a')`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  text-decoration: underline;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
`;

export const CXChatBanner = () => (
  <StyledContainer style={{ marginBottom: '0px' }}>
    <Typography variant="subtitle2">{cxChatBannerBodyText}&nbsp;</Typography>
    <StyledLink
      target="_blank"
      rel="noopener noreferrer"
      href="/apps/home/#/?action=NextivaCX"
      data-testid="PlatformAdminUI-CXChatBanner-StartSetupLink"
    >
      {cxChatBannerLinkText}
    </StyledLink>
  </StyledContainer>
);
